import type { MomentaryButtonWidget } from '../../../widgets';
import {
  BindingRow,
  CheckboxField,
  NumberField,
  ScalarField,
  Section,
  patcher,
  type WidgetEditorProps,
} from '../fields';

/** Impuls-Taster: schreiben, warten, zuruecknehmen. */
export function MomentaryButtonEditor(
  { widget, plantId, onChange }: WidgetEditorProps<MomentaryButtonWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Befehls-Datenpunkt"
          value={widget.commandPoint}
          plantId={plantId}
          filter={{ writable: true }}
          onChange={(next) => patch({ commandPoint: next })}
        />
      </Section>
      <Section
        title="Impuls"
        hint="Der Rücknahmewert geht nach Ablauf der Dauer automatisch raus."
      >
        <ScalarField
          label="Impulswert"
          value={widget.pulseValue}
          required
          onChange={(next) => patch({ pulseValue: next })}
        />
        <ScalarField
          label="Rücknahmewert"
          value={widget.releaseValue}
          hint="Leer lassen: der Renderer nimmt dann 0 beziehungsweise false."
          onChange={(next) => patch({ releaseValue: next })}
        />
        <NumberField
          label="Impulsdauer"
          unit="ms"
          value={widget.pulseDurationMs}
          min={0}
          integer
          onChange={(next) => patch({ pulseDurationMs: next })}
        />
        <CheckboxField
          label="Vor dem Schreiben rückfragen"
          checked={widget.confirmBeforeWrite}
          hint="Für alles, was eine Anlage bewegt: einmal nachfragen kostet eine Sekunde."
          onChange={(next) => patch({ confirmBeforeWrite: next })}
        />
      </Section>
    </>
  );
}
